export const locationSet = (location,account,team,license) => {
  return {
    type: 'location:set',
    location,
    account,
    team,
    license
  }
}

export const pathDirections = (path,location,account,team,license) => {
  return {
    type: 'location:directions',
    path,
    location,
    account,
    team,
    license
  }
}
